import { ColumnFilters } from 'components/DataTable/DataTable';

const useKeyFilter = <T,>(entities: T[], filters: ColumnFilters<T>[]) => {
  const filteredEntries = entities.filter((d) =>
    Object.entries(filters).every(([key, val]) => {
      const keyValue = d[key as keyof T] as unknown as string;
      const filterValues = val as unknown as string[];

      return filterValues.includes(keyValue);
    }),
  );
  return [filteredEntries as T[]] as const;
};

export default useKeyFilter;
